import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import ListCreator from '../../components/Lists/listCreator'
import { getCall } from '../helpers/componentApiHelpers/getCall'
import { getIdFromUrl } from '../helpers/getIdFromUrl'

import '../main.css'

class SonucCicekResimGaleri extends Component {

    constructor(props){
        super(props)
        this.state = {
            _id: "",
            data: "",
            dataCame: false
        }
    }

    async componentDidMount() {
        let id = getIdFromUrl(this.props.history.location.pathname, 2)
        await this.setState({_id: id})
        try{
            const getData = await getCall("/resultCicekGaleri/getall", {_id: this.state._id})
            await this.setState({dataCame: true, data: getData.data})
        }
        catch(err){
            console.log(err)
        }
    }

    render() {

        return (
            <React.Fragment>
                <HeaderLine header="Sonuç Çiçek" />
                <button onClick={() => this.props.history.push("/sonucCicekGaleriCreate/" + this.state._id)} className="blue-button add-new-button">Yeni Ekle</button>
                <ListCreator
                    data={this.state.data}
                    dataInfo={[
                        { className: "col-6 col-md-3 col-sm-6 col-lg-3", objectPropName: "image", header: "Resim" },
                    ]}
                    buttons={{
                        className: "col-2",
                        buttonData: [
                            { name: "Düzenle", func: (d) => {this.props.history.push("/sonucCicekGaleriCreate/" + d._id)} },
                            { name: "Sil" }
                        ]
                    }}
                    dataCame={this.state.dataCame}
                    endPoint="/resultCicek"
                />
            </React.Fragment>
        )
    }
}

export default SonucCicekResimGaleri